const processingTypeColoring = {
  unsubmitted: "type-unsubmitted",
  pending: 'type-pending',
  processing: "type-processing",
  failed: "type-failed",
  success: "type-success",
  copied: "type-copied"
}

const columns = [
  {
    key: 'projectName',
    name: ' Project Name',
    fieldName: 'projectName',
    headerClassName: 'DetailsListExample-header--FileIcon',
    className: "DetailsListExample-cell--FileIcon",
    iconClassName: "DetailsListExample-Header-FileTypeIcon",
    ariaLabel: "Column operations for File type",
    iconName: "CRMReport",
    isIconOnly: false,
    isResizable: true,
    minWidth: 20,
    maxWidth: 200,
    onColumnClick: this.onColumnClick,
  },
  {
    key: "multiBeds",
    name: " Multi Beds",
    fieldName: "multiBeds",
    headerClassName: "DetailsListExample-header--FileIcon",
    className: "DetailsListExample-cell--FileIcon",
    iconClassName: "DetailsListExample-Header-FileTypeIcon",
    iconName: "ContactCard",
    minWidth: 20,
    maxWidth: 200,
    isResizable: true,
    ariaLabel: "Multi beds on system",
    onColumnClick: this.onColumnClick,
    isMultiline: true,
  },
  {
    key: "city",
    name: " City",
    fieldName: "city",
    headerClassName: "DetailsListExample-header--FileIcon",
    className: "DetailsListExample-cell--FileIcon",
    iconClassName: "DetailsListExample-Header-FileTypeIcon",
    iconName: "POI",
    minWidth: 20,
    maxWidth: 200,
    isResizable: true,
    ariaLabel: 'Operations for city',
    onColumnClick: this.onColumnClick,
  },
  {
    key: 'state',
    name: ' State',
    fieldName: 'state',
    headerClassName: 'DetailsListExample-header--FileIcon',
    className: 'DetailsListExample-cell--FileIcon',
    iconClassName: 'DetailsListExample-Header-FileTypeIcon',
    iconName: 'POISolid',
    minWidth: 20,
    maxWidth: 200,
    isResizable: true,
    ariaLabel: 'Operations for state',
    onColumnClick: this.onColumnClick,
  },
  {
    key: 'type',
    name: ' Type',
    fieldName: 'translatedProjectType',
    headerClassName: 'DetailsListExample-header--FileIcon',
    className: 'DetailsListExample-cell--FileIcon',
    iconClassName: 'DetailsListExample-Header-FileTypeIcon',
    iconName: 'BulletedList2',
    minWidth: 20,
    maxWidth: 200,
    isResizable: true,
    ariaLabel: 'Operations for status',
    onColumnClick: this.onColumnClick,
  },
  {
    key: 'columnStatus',
    name: ' Processing Status',
    fieldName: 'columnStatus',
    headerClassName: 'DetailsListExample-header--FileIcon',
    className: 'DetailsListExample-cell--FileIcon',
    iconClassName: 'DetailsListExample-Header-FileTypeIcon',
    iconName: 'WorkItem',
    minWidth: 20,
    maxWidth: 200,
    isResizable: true,
    ariaLabel: 'Operations for status',
    onColumnClick: this.onColumnClick,
  },
    {
        key: "columnBomFileUrl",
        name: " BOM File",
        fieldName: "columnBomFileUrl",
        headerClassName: "DetailsListExample-header--FileIcon",
        className: "DetailsListExample-cell--FileIcon",
        iconClassName: "DetailsListExample-Header-FileTypeIcon",
        iconName: "ZipFolder",
        minWidth: 20,
        maxWidth: 200,
        isResizable: true,
        ariaLabel: "Operations for status",
        onColumnClick: this.onColumnClick,
    },
    {
        key: "columnCsvFileUrl",
        name: " CSV File",
        fieldName: "columnCsvFileUrl",
        headerClassName: "DetailsListExample-header--FileIcon",
        className: "DetailsListExample-cell--FileIcon",
        iconClassName: "DetailsListExample-Header-FileTypeIcon",
        iconName: "ZipFolder",
        minWidth: 20,
        maxWidth: 200,
        isResizable: true,
        ariaLabel: "Operations for status",
        onColumnClick: this.onColumnClick,
    },
    {
        key: "columnResult",
        name: " Result",
        fieldName: "columnResult",
        headerClassName: "DetailsListExample-header--FileIcon",
        className: "DetailsListExample-cell--FileIcon",
    iconClassName: 'DetailsListExample-Header-FileTypeIcon',
    iconName: 'ZipFolder',
    minWidth: 20,
    maxWidth: 200,
    isResizable: true,
    ariaLabel: 'Operations for status',
    onColumnClick: this.onColumnClick,
  },
  {
    key: 'columnEditedDate',
    name: ' Edited Date',
    fieldName: 'columnEditedDate',
    headerClassName: 'DetailsListExample-header--FileIcon',
    className: 'DetailsListExample-cell--FileIcon',
    iconClassName: 'DetailsListExample-Header-FileTypeIcon',
    iconName: 'Calendar',
    minWidth: 20,
    maxWidth: 200,
    isResizable: true,
    ariaLabel: 'Operations for status',
    onColumnClick: this.onColumnClick,
  },
  {
    key: 'columnCreateDate',
    name: ' Created Date',
    fieldName: 'columnCreatedDate',
    headerClassName: 'DetailsListExample-header--FileIcon',
    className: 'DetailsListExample-cell--FileIcon',
    iconClassName: 'DetailsListExample-Header-FileTypeIcon',
    iconName: 'Calendar',
    minWidth: 20,
    maxWidth: 200,
    isResizable: true,
    ariaLabel: 'project creation date',
    onColumnClick: this.onColumnClick,
  },

];

export {
  columns,
  processingTypeColoring
};



// WEBPACK FOOTER //
// ./src/components/ProjectsCrud/project-detail-list-columns.js